/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'

const entity = {
  longId: {
    displayName: 'voucherCode',
  },
  totalAmount: {},
  leftAmount: {},
  createdAt: {
    type: IKDataEntity.Types.Date,
  },

}
const config = {
  load: async function (filter) {
    const [fromDate, toDate] = filter[0].dateFilter
    console.log(fromDate, toDate, '选择时间')
    const list = (await hillo.get('MemberCard.php', {
      op: 'showAllMemberCardSaleRecord',
    })).content.filter(item => {
      return item.createdAt > fromDate && item.createdAt < toDate
    })
    return list
  },
}

export async function getCouponRecord (id) {
  return (await hillo.get('MemberCard.php', {
    op: 'getOne',
    withConsumeLog: true,
    id,
  })).content
}

export default IKDataEntity.ModelFactory(entity, config)
